// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".e7c6dfbc373ba63754794814b785cddf34039f2f.chunk.bundle.js";
};